import { ComponentThemeType } from './theme.types';

export const inputsTheme: ComponentThemeType = {
  MuiTextField: {
    defaultProps: {
      InputLabelProps: {
        shrink: true,
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: ({ theme: { palette } }) => ({
        '.MuiInputBase-input:not(.MuiInputBase-inputSizeSmall)': { padding: '13px 14px;' },
        color: palette.tertiary.light,
      }),
    },
  },
};
